<template>
  <ul>
    <li class="emoj-action" @click="toggleEmojGroupList">
      <a href="javascript:;"><i class="bx bx-smile"></i></a>
      <div
        class="emoj-group-list"
        :style="{ display: emojGroupListVisible ? 'block' : 'none' }"
      >
        <ul>
          <li>
            <a href="javascript:;"
              ><img src="@/assets/img/icon/emoj-icon-01.svg" alt="Icon"
            /></a>
          </li>
          <li>
            <a href="javascript:;"
              ><img src="@/assets/img/icon/emoj-icon-02.svg" alt="Icon"
            /></a>
          </li>
          <li>
            <a href="javascript:;"
              ><img src="@/assets/img/icon/emoj-icon-03.svg" alt="Icon"
            /></a>
          </li>
          <li>
            <a href="javascript:;"
              ><img src="@/assets/img/icon/emoj-icon-04.svg" alt="Icon"
            /></a>
          </li>
          <li>
            <a href="javascript:;"
              ><img src="@/assets/img/icon/emoj-icon-05.svg" alt="Icon"
            /></a>
          </li>
          <li class="add-emoj">
            <a href="javascript:;"><i class="feather-plus"></i></a>
          </li>
        </ul>
      </div>
    </li>
    <li>
      <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#forward-message"
        ><i class="bx bx-share"></i
      ></a>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      emojGroupListVisible: false,
    };
  },
  methods: {
    toggleEmojGroupList() {
      this.emojGroupListVisible = !this.emojGroupListVisible;
    },
  },
};
</script>
